<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="下级渠道商列表" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <el-form
              class="jc-table-actionBar-item"
              :inline="true"
              :model="form"
            >
              <el-form-item>
                <!-- <router-link  class="jc-button jc-button--primary" :to="{name: 'serviceProviderCreate'}">新增下级渠道商</router-link> -->
                <el-button
                  type="primary"
                  @click="$router.push({ name: 'serviceProviderCreate' })"
                  >新增下级渠道商</el-button
                >
              </el-form-item>
            </el-form>

            <el-form
              class="jc-table-actionBar-item jc-box-table-action"
              :inline="true"
              :model="form"
            >
              <el-form-item label="渠道商名称：">
                <el-input v-model.trim="form.distributorName"></el-input>
              </el-form-item>

              <el-form-item label="审批状态：">
                <el-select v-model="form.status" placeholder="请选择">
                  <el-option
                    v-for="item in approvalStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="queryList('query')"
                  >查询</el-button
                >
              </el-form-item>

              <el-form-item>
                <el-button @click="exportList" class="jc-button-icon"
                  ><i class="jc-icon-download"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table class="form-loading" :data="tableData" style="width: 100%">
            <el-table-column prop="distributorName" label="渠道商名称">
              <template slot-scope="scope">{{
                scope.row.distributorName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="pin" label="PIN">
              <template slot-scope="scope">{{
                scope.row.pin | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="loginName" label="账号名">
              <template slot-scope="scope">{{
                scope.row.loginName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="contracter" label="联系人姓名">
              <template slot-scope="scope">{{
                scope.row.contracter | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="tel" label="联系电话" width="110">
              <template slot-scope="scope">{{
                scope.row.tel | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="email" label="邮箱">
              <template slot-scope="scope">{{
                scope.row.email | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="settleTime" label="入驻时间">
              <template slot-scope="scope">{{
                scope.row.settleTimeStr | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="customerCount" label="客户数">
              <template slot-scope="scope">{{
                scope.row.customerCount | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <span
                  :class="{
                    'jc-status-progress': scope.row.status === 0,
                    'jc-status-success': scope.row.status === 1,
                    'jc-status-danger': scope.row.status === 2,
                  }"
                  >{{
                    scope.row.status === 0
                      ? '审批中'
                      : scope.row.status === 1
                        ? '已入驻'
                        : scope.row.status === 2
                          ? '驳回'
                          : scope.row.status === 3
                            ? '已停止合作'
                            : '--'
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="openDetail(scope.row)"
                  >详情</el-button
                >
                <el-button type="text" @click="deleteDistributor(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="jc-container-table-actionBar" v-if="total > 10">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageIndex"
              :page-sizes="[10, 20, 50]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APPROVAL_STATUS } from '@/utils/constant.js'
import {
  getSubDistributorList,
  exportSubDistributorList,
  deleteDistributorLevelTwo,
} from '@/api/distributor-api.js'
import routerMixins from '@/mixins/router-mixins.js'
export default {
  mixins: [routerMixins],
  data() {
    return {
      currentPage1: 1,
      form: {
        distributorName: '',
        status: '',
        pageSize: 10,
        pageIndex: 1,
      },
      total: 0,
      tableData: [],
      approvalStatus: APPROVAL_STATUS,
    }
  },
  activated() {
    this.queryList()
  },
  methods: {
    handleSizeChange(val) {
      this.form.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val
      this.queryList()
    },
    async queryList(query) {
      if (query) {
        this.form.pageIndex = 1
      }
      try {
        let { result } = await getSubDistributorList(this.form)
        this.tableData = (result && result.result) || ''
        this.total =
          (result && result.pagination && result.pagination.numberRecords) || 0
      } catch (e) {
        console.log(e)
        this.tableData = []
        this.total = 0
      }
    },
    async exportList() {
      try {
        let { result } = await exportSubDistributorList(this.form)
        window.location.href = eval("'" + result.uri + "'")
      } catch (e) {
        console.log(e)
      }
    },
    newProvider() {
      this.$router.push({
        name: 'serviceProviderCreate',
      })
    },
    async deleteDistributor(row) {
      let distributorId = row.distributorId
      let name = row.distributorName
      const h = this.$createElement
      this.$jcmsgbox({
        title: '删除',
        message: h('div', null, [
          h('p', null, '二级渠道商一经删除不可恢复，'),
          h('p', null, `确认删除二级渠道商: ${name}?`),
        ]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            await deleteDistributorLevelTwo({
              distributorId,
            })
            this.$jcNotify({
              type: 'success',
              message: '删除成功!',
            })
            this.queryList()
          } catch (e) {
            console.log(e)
            let msg = e.message
            this.$jcNotify({
              type: 'error',
              message: `删除失败:${msg}`,
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    openDetail(row) {
      this.$router.push({
        name: 'serviceProviderDetail',
        params: { id: row.distributorId },
      })
    },
  },
}
</script>
